var _defs, _path, _path2, _path3, _path4, _rect, _rect2, _path5, _path6, _path7, _rect3, _rect4, _path8, _rect5, _rect6, _path9, _path10, _path11, _path12, _path13, _g, _path14, _circle, _circle2, _path15, _path16, _path17, _path18, _path19;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPerfectMonth(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "perfect_month_svg__Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 840 1040",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".perfect_month_svg__cls-1{fill:#2a848e}.perfect_month_svg__cls-10,.perfect_month_svg__cls-12,.perfect_month_svg__cls-16,.perfect_month_svg__cls-3,.perfect_month_svg__cls-8{fill:none}.perfect_month_svg__cls-3{stroke:#006c78}.perfect_month_svg__cls-10,.perfect_month_svg__cls-12,.perfect_month_svg__cls-16,.perfect_month_svg__cls-3,.perfect_month_svg__cls-8{stroke-linecap:round;stroke-linejoin:round}.perfect_month_svg__cls-3{stroke-width:16px}.perfect_month_svg__cls-4{fill:#fff}.perfect_month_svg__cls-5{fill:#fed3d7}.perfect_month_svg__cls-6{fill:#024447}.perfect_month_svg__cls-8{stroke:#cae0e3}.perfect_month_svg__cls-12,.perfect_month_svg__cls-16,.perfect_month_svg__cls-8{stroke-width:8px}.perfect_month_svg__cls-9{isolation:isolate}.perfect_month_svg__cls-10{stroke:#024447;stroke-width:2px}.perfect_month_svg__cls-12{stroke:#46c65e}.perfect_month_svg__cls-16{stroke:#fd934f}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-1",
    d: "M648.77 719.16V423.59A228.77 228.77 0 00420 194.83c-126.34 0-228.76 102.42-228.76 228.76v295.57h457.53z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M648.77 719.16V423.59a229.787 229.787 0 00-3.67-41 69.182 69.182 0 00-51.05 34.36 70.973 70.973 0 00-6.71 15.67H252.66a70.971 70.971 0 00-6.71-15.67 69.164 69.164 0 00-51.05-34.36 229.785 229.785 0 00-3.67 41v295.57h457.53z",
    fill: "#20747c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-1",
    d: "M537.664 150.211a31.436 31.436 0 010 44.435l-66.065 66.065a31.436 31.436 0 01-44.435 0l-22.217-22.217 88.275-88.276a31.436 31.436 0 0144.435 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-3",
    d: "M300.89 307.82a54.913 54.913 0 0138.9-16.18 54.93 54.93 0 0138.9 16.18M461.31 307.82a54.913 54.913 0 0138.9-16.18 54.93 54.93 0 0138.9 16.18"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "perfect_month_svg__cls-4",
    x: 280.33,
    y: 354.99,
    width: 118.93,
    height: 168.19,
    rx: 59.46
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "perfect_month_svg__cls-4",
    x: 440.75,
    y: 354.99,
    width: 118.93,
    height: 168.19,
    rx: 59.46
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-5",
    d: "M280.33 432.63v31.09a59.632 59.632 0 0059.46 59.46 59.632 59.632 0 0059.46-59.46v-31.09H280.33zM559.67 463.72v-31.09H440.74v31.09a59.632 59.632 0 0059.46 59.46 59.632 59.632 0 0059.46-59.46z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-1",
    d: "M481.14 131.59a31.436 31.436 0 010 44.434l-66.065 66.065a31.436 31.436 0 01-44.434 0l-22.218-22.217 88.275-88.276a31.436 31.436 0 0144.435 0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-3",
    d: "M436.71 131.59a31.506 31.506 0 0144.43 0 31.506 31.506 0 010 44.43l-50.92 50.92"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "perfect_month_svg__cls-6",
    x: 302.45,
    y: 398.88,
    width: 81.89,
    height: 126.75,
    rx: 40.94
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "perfect_month_svg__cls-6",
    x: 455.66,
    y: 398.88,
    width: 81.89,
    height: 126.75,
    rx: 40.94
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-5",
    d: "M359.76 466.45l23.56 13.6a4.847 4.847 0 007.27-4.2v-27.2a4.85 4.85 0 00-7.27-4.2l-23.56 13.6a4.852 4.852 0 000 8.4zM480.24 466.45l-23.56 13.6a4.847 4.847 0 01-7.27-4.2v-27.2a4.85 4.85 0 017.27-4.2l23.56 13.6a4.852 4.852 0 010 8.4z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "perfect_month_svg__cls-4",
    x: 83,
    y: 470.63,
    width: 669,
    height: 455.81,
    rx: 20
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 470.63,
    width: 669,
    height: 455.81,
    rx: 20,
    stroke: "#cae0e3",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-8",
    d: "M702 590.32v269.55M133 859.87V590.32M214.28 859.87V590.32M295.57 859.87V590.32M376.85 859.87V590.32M458.14 859.87V590.32M539.42 859.87V590.32M620.71 859.87V590.32"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-1",
    d: "M202.67 501.92l17.3-29.97c15.4-26.67-3.85-60-34.64-60h-34.61c-30.79 0-50.04 33.33-34.64 60l17.3 29.97c15.4 26.67 53.89 26.67 69.28 0z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-3",
    d: "M116.08 471.95l8.65 14.99 8.65 14.99a39.998 39.998 0 0069.28 0l8.65-14.99 8.65-14.99"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-1",
    d: "M637.33 501.92l-17.3-29.97c-15.4-26.67 3.85-60 34.64-60h34.61c30.79 0 50.04 33.33 34.64 60l-17.3 29.97c-15.4 26.67-53.89 26.67-69.28 0z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-3",
    d: "M723.92 471.95l-8.65 14.99-8.65 14.99a39.998 39.998 0 01-69.28 0l-8.65-14.99-8.65-14.99"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "perfect_month_svg__cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "perfect_month_svg__cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-6",
    d: "M340.954 504.843h18.178V565.3H347.36v-40.893q0-1.763.041-4.942.04-3.179.041-4.902L335.985 565.3h-12.277l-11.375-50.737q0 1.723.041 4.902.04 3.179.041 4.942V565.3h-11.771v-60.457h18.382l11.005 47.537z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "perfect_month_svg__cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-10",
    d: "M340.954 504.843h18.178V565.3H347.36v-40.893q0-1.763.041-4.942.04-3.179.041-4.902L335.985 565.3h-12.277l-11.375-50.737q0 1.723.041 4.902.04 3.179.041 4.942V565.3h-11.771v-60.457h18.382l11.005 47.537z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "perfect_month_svg__cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-6",
    d: "M406.348 559.831q-5.66 6.986-17.185 6.986-11.527 0-17.186-6.986a27.738 27.738 0 010-33.584q5.66-7.09 17.186-7.09t17.185 7.09a27.738 27.738 0 010 33.584zm-9.351-6.46q2.747-3.647 2.748-10.363 0-6.716-2.748-10.341a10.389 10.389 0 00-15.77 0q-2.77 3.624-2.77 10.34 0 6.719 2.77 10.363a10.352 10.352 0 0015.77 0z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "perfect_month_svg__cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-10",
    d: "M406.348 559.831q-5.66 6.986-17.185 6.986-11.527 0-17.186-6.986a27.738 27.738 0 010-33.584q5.66-7.09 17.186-7.09t17.185 7.09a27.738 27.738 0 010 33.584zm-9.351-6.46q2.747-3.647 2.748-10.363 0-6.716-2.748-10.341a10.389 10.389 0 00-15.77 0q-2.77 3.624-2.77 10.34 0 6.719 2.77 10.363a10.352 10.352 0 0015.77 0z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "perfect_month_svg__cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-6",
    d: "M454.766 523.156q4.39 3.63 4.39 12.038V565.3H447.18v-27.194a12.478 12.478 0 00-.937-5.414q-1.71-3.445-6.514-3.445-5.904 0-8.102 5.045a17.429 17.429 0 00-1.14 6.809V565.3h-11.69v-44.625h11.32v6.521a19.814 19.814 0 014.248-4.963 14.715 14.715 0 019.108-2.707q6.902 0 11.293 3.63z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "perfect_month_svg__cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-10",
    d: "M454.766 523.156q4.39 3.63 4.39 12.038V565.3H447.18v-27.194a12.478 12.478 0 00-.937-5.414q-1.71-3.445-6.514-3.445-5.904 0-8.102 5.045a17.429 17.429 0 00-1.14 6.809V565.3h-11.69v-44.625h11.32v6.521a19.814 19.814 0 014.248-4.963 14.715 14.715 0 019.108-2.707q6.902 0 11.293 3.63z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "perfect_month_svg__cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-6",
    d: "M463.481 529.33v-8.327h6.235v-12.469h11.566v12.469h7.26v8.326h-7.26v23.625q0 2.748.698 3.425t4.265.677c.355 0 .732-.007 1.128-.02q.593-.021 1.169-.062v8.736l-5.537.205q-8.285.287-11.32-2.871-1.97-2.01-1.97-6.193v-27.522z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "perfect_month_svg__cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-10",
    d: "M463.481 529.33v-8.327h6.235v-12.469h11.566v12.469h7.26v8.326h-7.26v23.625q0 2.748.698 3.425t4.265.677c.355 0 .732-.007 1.128-.02q.593-.021 1.169-.062v8.736l-5.537.205q-8.285.287-11.32-2.871-1.97-2.01-1.97-6.193v-27.522z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "perfect_month_svg__cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-6",
    d: "M526.814 520.84a13.13 13.13 0 015.536 4.392 11.713 11.713 0 012.245 5.154 63.685 63.685 0 01.409 8.64V565.3h-11.936v-27.225a12.054 12.054 0 00-1.222-5.83q-1.588-3.12-6.026-3.121a8.267 8.267 0 00-6.982 3.1q-2.382 3.1-2.381 8.85V565.3h-11.69v-60.252h11.69v21.328a14.29 14.29 0 015.86-5.435 16.503 16.503 0 017.003-1.538 18.933 18.933 0 017.494 1.437z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "perfect_month_svg__cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-10",
    d: "M526.814 520.84a13.13 13.13 0 015.536 4.392 11.713 11.713 0 012.245 5.154 63.685 63.685 0 01.409 8.64V565.3h-11.936v-27.225a12.054 12.054 0 00-1.222-5.83q-1.588-3.12-6.026-3.121a8.267 8.267 0 00-6.982 3.1q-2.382 3.1-2.381 8.85V565.3h-11.69v-60.252h11.69v21.328a14.29 14.29 0 015.86-5.435 16.503 16.503 0 017.003-1.538 18.933 18.933 0 017.494 1.437z"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-8",
    d: "M133 659.23h569M133 726.11h569M133 590.32h569M133 792.99h569M133 859.87h569"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    fill: "#cae0e3",
    opacity: 0.3,
    d: "M539.42 591.31h162.57v266.08H539.42z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "perfect_month_svg__cls-4",
    cx: 343.39,
    cy: 422.77,
    r: 10.17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "perfect_month_svg__cls-4",
    cx: 496.61,
    cy: 422.77,
    r: 10.17
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-12",
    d: "M161.87 625.84l7.19 7.2 16.35-16.35M243.07 625.84l7.2 7.2 16.34-16.35M324.28 625.84l7.19 7.2 16.35-16.35M405.48 625.84l7.19 7.2 16.35-16.35M486.68 625.84l7.2 7.2 16.34-16.35M161.87 690.19l7.19 7.2 16.35-16.35M243.07 690.19l7.2 7.2 16.34-16.35M324.28 690.19l7.19 7.2 16.35-16.35M405.48 690.19l7.19 7.2 16.35-16.35M486.68 690.19l7.2 7.2 16.34-16.35M161.87 754.54l7.19 7.19 16.35-16.34M243.07 754.54l7.2 7.19 16.34-16.34M324.28 754.54l7.19 7.19 16.35-16.34M405.48 754.54l7.19 7.19 16.35-16.34M486.68 754.54l7.2 7.19 16.34-16.34M161.87 818.89l7.19 7.19 16.35-16.34M243.07 818.89l7.2 7.19 16.34-16.34M324.28 818.89l7.19 7.19 16.35-16.34M405.48 818.89l7.19 7.19 16.35-16.34M486.68 818.89l7.2 7.19 16.34-16.34"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M701.54 731.84l-40.52-25.87-40.52 25.87a1.761 1.761 0 01-2.71-1.49v-93.36a1.763 1.763 0 011.76-1.76h82.94a1.763 1.763 0 011.76 1.76v93.36a1.768 1.768 0 01-2.71 1.49z",
    fill: "#fa505e",
    stroke: "#fa505e",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M692.99 682.16a15.239 15.239 0 01-9-2.97l-22.97-16.69-22.97 16.69a15.26 15.26 0 01-9 2.97 15.535 15.535 0 01-12.51-6.42 15.156 15.156 0 01-2.13-13.73l8.77-27-22.97-16.69a15.369 15.369 0 019.03-27.8h28.39l8.77-27a15.36 15.36 0 0129.22 0l8.77 27h28.39a15.369 15.369 0 019.03 27.8l-22.96 16.69 8.77 27a15.111 15.111 0 01-2.13 13.72 15.535 15.535 0 01-12.51 6.42z",
    fill: "#fee066"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M661.02 560.93a7.228 7.228 0 017 5.09l8.92 27.44a7.37 7.37 0 007 5.09h28.85a7.364 7.364 0 014.33 13.32l-23.34 16.96a7.376 7.376 0 00-2.68 8.23l8.92 27.44a7.387 7.387 0 01-7.03 9.67 7.233 7.233 0 01-4.3-1.44l-23.34-16.96a7.354 7.354 0 00-8.66 0l-23.34 16.96a7.255 7.255 0 01-4.3 1.44 7.387 7.387 0 01-7.03-9.67l8.91-27.44a7.352 7.352 0 00-2.67-8.23l-23.34-16.96a7.363 7.363 0 014.33-13.32h28.85a7.348 7.348 0 007-5.09l8.91-27.44a7.228 7.228 0 017-5.09m0-16a23.315 23.315 0 00-22.22 16.14l-6.98 21.47h-22.57a23.359 23.359 0 00-13.73 42.26l18.26 13.27-6.98 21.47a23.077 23.077 0 003.26 20.9 23.573 23.573 0 0018.98 9.72 23.153 23.153 0 0013.71-4.5L661 672.39l18.26 13.27a23.22 23.22 0 0013.71 4.5 23.532 23.532 0 0018.98-9.72 23.047 23.047 0 003.26-20.9l-6.98-21.47 18.26-13.27a23.359 23.359 0 00-13.73-42.26h-22.57l-6.98-21.47a23.302 23.302 0 00-22.22-16.14h.02z",
    fill: "#fd934f"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "perfect_month_svg__cls-16",
    d: "M649.18 613.02v5.95M672.85 613.02v5.95M667.84 631.93a9.657 9.657 0 01-13.64 0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfectMonth);
export default ForwardRef;